// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Swiper__wrapper__162b7fee","list":"Swiper__list__162b7fee","item":"Swiper__item__162b7fee"};